import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
// import NotificationsRest from '../../services/NotificationRestAPI';
import { fetchTodayTask } from '../../actions/bell.action';
import { Avatar, Card, CardContent, CardHeader, Grid, Typography } from '@material-ui/core';
import {indigo, cyan} from '@material-ui/core/colors';
import {format, isValid} from 'date-fns';

const CardTask = props => {
  const {subject, projectTitle, dateDue, progress, notes, status} = props;
  let bgColor=status==='assigned'?indigo['800']:cyan['500'];
  return (
    <Grid item xs={12} ms={12} md={6}>
      <Card >
        <LinearProgress color='secondary' variant="determinate" value={progress}/>
        <CardHeader
          avatar={
            <Avatar style={{backgroundColor:bgColor}}>{''}</Avatar>
          }
          title={projectTitle+':'+subject}
          subheader={dateDue&&isValid(new Date(dateDue))?format(new Date(dateDue), 'cccc dd MMMM yyy'):''}
        />
     
        <CardContent>
          <Typography variant="body2" color="textSecondary" component="p">
            {notes}
          </Typography>
        </CardContent> 
      </Card>
    </Grid>

  );
};

const TasksCardDeck = (props) => {
  const {userInfo:{_id}, bellTasks} = props;
  const [loading, setLoading] = useState(false);
  // const [time, setTime] = useState(0);

  useEffect(() => {
    async function initialize () {
      // let start = window.performance.now();
      setLoading(true);
      await props.fetchTodayTask(_id);
      // setTodayTasks(result);

      // let end = window.performance.now();
      // setTime(end - start);
      setLoading(false);
    }
    initialize();
  }, []);

  let renderedCard=[];
  bellTasks.forEach(project => {
    let projectTitle = project.projectTitle;
    let tasksCard = project.tasks.map(task => {
      return <CardTask key={task._id} projectTitle={projectTitle} {...task} />;
    });
    renderedCard.push(...tasksCard);
  });
  return (
    <>
      {loading&& <LinearProgress />}
      {/* {time }  */}
      {!loading&&
      <Grid container direction="row" justify="space-between" alignItems="center" spacing={2} >
        {renderedCard}
      </Grid>}
    </>
  );
};

const mapStateToProps = (state) => ({
  userInfo:state.authReducer.user,
  bellTasks: state.bellReducer.task,

});


const mapDispatchToProps = (dispatch) => {
  return {
    fetchTodayTask: (_id) => dispatch(fetchTodayTask(_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TasksCardDeck);
